<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header card-header-squirrel">
            <h4 class="card-title">{{this.translate.data['EDITPROFILE'] | translate}}</h4>
          </div>
          @if (userProfile) {
            <div class="card-body">
              @if (isLoadingResults || isRateLimitReached) {
                <div class="example-loading-shade" >
                  <mat-spinner></mat-spinner>
                  @if (isRateLimitReached) {
                    <div class="example-rate-limit-reached">
                      Squirrel's API rate limit has been reached. It will be reset in one minute.
                    </div>
                  }
                </div>
              }
              <form [formGroup]="userProfileForm" novalidate>
                <div class="row">
                  <!-- <div class="col-md-6">
                  <mat-form-field class="example-full-width">
                    <input matInput placeholder="{{this.translate.data['USERNAME'] | translate}}"  formControlName="userName" readonly>
                  </mat-form-field>
                </div> -->
                <div class="col-md-6">
                  @if (userProfile.isEmailConfirmed) {
                    <mat-form-field class="example-full-width">
                      <input matInput  placeholder="{{this.translate.data['EMAIL'] | translate}}" formControlName="email" readonly>
                    </mat-form-field>
                  } @else {
                    <mat-form-field class="example-full-width">
                      <input matInput  placeholder="{{this.translate.data['EMAIL'] | translate}}" formControlName="email" readonly>
                    </mat-form-field>
                    <!-- <button mat-raised-button class="btn btn-squirrel" (click)="SendVerificationEmail(userProfile.email)">{{this.translate.data['SENDEMAIL'] | translate}}</button> -->
                  }
                  <!-- <ng-template #emailed>
                  <mat-form-field class="example-full-width">
                    <input matInput  placeholder="{{this.translate.data['EMAIL'] | translate}}" formControlName="email" readonly>
                  </mat-form-field>
                </ng-template> -->
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <mat-form-field class="example-full-width">
                  <input matInput  placeholder="{{this.translate.data['FIRSTNAME'] | translate}}" formControlName="givenName">
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field class="example-full-width">
                  <input matInput placeholder="{{this.translate.data['LASTNAME'] | translate}}" formControlName="familyName">
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <!-- <div class="col-md-6">
              <mat-form-field class="example-full-width">
                <input matInput  placeholder="{{this.translate.data['FULLNAME'] | translate}}" formControlName="fullName">
              </mat-form-field>
            </div> -->
            <div class="col-md-6">
              <mat-form-field class="example-full-width">
                <input matInput placeholder="{{this.translate.data['PHONENUMBER'] | translate}}" formControlName="phoneNumber">
              </mat-form-field>
            </div>
          </div>
          <!-- <div class="row">
          <div class="col-md-4">
            <mat-form-field class="example-full-width">
              <input matInput placeholder="{{this.translate.data['STREETADDRESS'] | translate}}"  formControlName="streetAddress">
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-full-width">
              <input matInput  placeholder="{{this.translate.data['POSTALCODE'] | translate}}" formControlName="postalCode">
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field class="example-full-width">
              <input matInput  placeholder="{{this.translate.data['LOCALITY'] | translate}}" formControlName="locality">
            </mat-form-field>
          </div>
          <div class="col-md-4">
            <mat-form-field class="example-full-width">
              <input matInput  placeholder="{{this.translate.data['COUNTRY'] | translate}}" formControlName="country">
            </mat-form-field>
          </div>
          <div class="col-md-2">
            <mat-form-field class="example-full-width">
              <input matInput  placeholder="{{this.translate.data['REGION'] | translate}}" formControlName="region">
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field class="example-full-width">
              <input matInput  placeholder="{{this.translate.data['WEBSITE'] | translate}}" formControlName="webSite">
            </mat-form-field>
          </div>
        </div> -->
        <!-- <div class="row">
        <div class="col-md-4">
          <mat-form-field class="example-full-width">
            <input matInput  placeholder="{{this.translate.data['PROFILEURL'] | translate}}" formControlName="profile">
          </mat-form-field>
        </div>
      </div> -->
      <button mat-raised-button class="btn btn-squirrel"  matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}"
      (click)="cancel()" >Schließen</button>
      <span style="flex: 1 1 auto"></span>
      <button mat-raised-button type="submit" class="btn btn-squirrel pull-right" (click)="updateUser()">{{this.translate.data['BTNUPDATEPROFILE'] | translate}}</button>
      <div class="clearfix"></div>
    </form>
  </div>
}
</div>
</div>
<!-- <div class="col-md-4">
<div class="card card-profile">
  <div class="card-avatar">
    <a href="javascript:void(0)">
      <img class="img" src="{{avatar}}" />
    </a>
  </div>
  <div class="card-body">
    <h4 class="card-title">{{userProfile.username}}</h4>
    <p class="card-description">
    </p>
  </div>
</div>
</div> -->
</div>
</div>
</div>